// extracted by mini-css-extract-plugin
module.exports = {"title":"Footer_title__3AHfg","copyright":"Footer_copyright__21U3w","footer":"Footer_footer__2HjT5","footerLink":"Footer_footerLink__1ro5j"};